import {useContext} from 'solid-js'
import {PlayerProviderBehavior, PlayerProviderContext} from './PlayerProviderContext'

export const usePlayer = () => {
    const context: PlayerProviderBehavior | undefined = useContext(PlayerProviderContext)
    if (!context) {
        throw new Error(
            'could not find redux context value; please ensure the component is wrapped in a <ReduxProvider>'
        )
    }
    return context
}
